import Hero from '../../Hero';
import Overlay from '../../Overlay';
import React, { forwardRef, useState } from 'react';
import EmployeeLoader from '../EmployeeLoader';
import Content from '../../Content';
import BranchLoader from '../BranchLoader';
import IBuildrProps from 'src/utilities/IBuildrProps';
import classNames from 'classnames';

export interface IMeetTheTeamPageProps extends IBuildrProps{
    heroSrc: string;
    heroAlt: string;
    title: string;
    subtitle: string;
    body: string;
    color: string;
    hideBranchDropdown: boolean;
    employeeDepartment: string;
}

const MeetTheTeamPage = forwardRef((props: IMeetTheTeamPageProps, ref: any) => {
    const [filter, setFilter] = useState("");

    function handleFilterChange(e) {
        setFilter(e.target.value)
    }

    return (
        <div data-id={props.cmsId} ref={ref} className={classNames(props.className, props.editorClassObj)}>
            <Hero src={props.heroSrc} alt={props.heroAlt}>
                <Overlay title={props.title} subtitle={props.subtitle} body={props.body} color={props.color}>
                    {!props.hideBranchDropdown ? <BranchLoader onChange={handleFilterChange} /> : <></>}
                </Overlay>
            </Hero>
            <Content underhang className="px-5 py-6">
                <EmployeeLoader filter={filter} employeeDepartment={props.employeeDepartment} />
            </Content>
        </div>
    );
});

export default MeetTheTeamPage;